






import { embedDashboard } from 'fork-superset-ui-without-optional-chaining-operator';
import Axios from 'axios';
import { Component, Mixins } from 'vue-property-decorator';
import Http from '../mixins/http';
import LocalData from '../mixins/local-data';

@Component({
    components: {},
})
export default class KpiPanel extends Mixins(LocalData, Http) {
    async fetchGuest() {
        try {
            const { data } = await Axios.post(
                process.env.VUE_APP_SUPERSET_DOMAIN + '/api/v1/security/login', // endpoint superset login
                {
                    password: process.env.VUE_APP_SUPERSET_PASSWORD,
                    provider: process.env.VUE_APP_SUPERSET_PROVIDER,
                    refresh: true,
                    username: process.env.VUE_APP_SUPERSET_USERNAME,
                },
                { withCredentials: true }, // cookie for charts
            );

            const { data: guest_token } = await Axios.post(
                process.env.VUE_APP_SUPERSET_DOMAIN + '/api/v1/security/guest_token/', // endpoint superset guest_token
                {
                    user: {
                        username: process.env.VUE_APP_SUPERSET_USERNAME, // username who can seeing dashboard
                        first_name: process.env.VUE_APP_SUPERSET_FIRST_NAME,
                        last_name: process.env.VUE_APP_SUPERSET_LAST_NAME,
                    },
                    resources: [
                        {
                            type: 'dashboard',
                            id: process.env.VUE_APP_SUPERSET_ID_EMBEDDED_DASHBOARD, // id embedded dashboard
                        },
                    ],
                    rls: [],
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + data.access_token, // access_token for getting guest_token
                    },
                    withCredentials: true, // cookie for charts
                },
            );
            return guest_token.token; // guest_token for embedded dashboard
        } catch (error) {
            console.log(error);
        }
    }

    mounted() {
        embedDashboard({
            id: `${process.env.VUE_APP_SUPERSET_ID_EMBEDDED_DASHBOARD}?native_filters=${localStorage.getItem(
                'FILTER_FOR_SUPERSET',
            )}`, // given by the Superset embedding UI
            supersetDomain: process.env.VUE_APP_SUPERSET_DOMAIN,
            mountPoint: this.$refs.iframe as HTMLElement, // any html element that can contain an iframe
            fetchGuestToken: () => this.fetchGuest(),
            iframeSandboxExtras: ['allow-popups-to-escape-sandbox'],
        });
    }

    created() {
        if (this.$disallowedModules.includes('kpi-panel')) {
            this.$router.replace('/calc');
        }
    }
}
